var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSidebarIcon3 = function SvgSidebarIcon3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.00390625,
    width: 18,
    height: 18,
    rx: 9,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76763 11.0809C6.76763 10.9549 6.88103 10.8289 7.01963 10.8289H8.02763C8.16623 10.8289 8.27963 10.9423 8.27963 11.0683C8.29223 11.6731 8.53163 11.8243 8.89703 11.8243C9.27503 11.8243 9.52703 11.5345 9.52703 11.1691V10.3753C9.52703 10.0099 9.27503 9.73269 8.89703 9.73269H8.56943C8.44343 9.73269 8.33003 9.61929 8.33003 9.48069V8.72469C8.33003 8.58609 8.44343 8.47269 8.56943 8.47269H8.89703C9.27503 8.47269 9.52703 8.19549 9.52703 7.83009V7.03629C9.52703 6.67089 9.27503 6.38109 8.89703 6.38109C8.53163 6.38109 8.29223 6.53229 8.27963 7.13709C8.27963 7.26309 8.16623 7.37649 8.02763 7.37649H7.01963C6.88103 7.37649 6.76763 7.25049 6.76763 7.12449C6.81803 5.67549 7.76303 5.12109 8.89703 5.12109C10.0688 5.12109 11.039 5.91489 11.039 7.06149V7.79229C11.039 8.27109 10.8248 8.73729 10.3838 9.12789C10.85 9.53109 11.039 10.0225 11.039 10.5139V11.1439C11.039 12.2905 10.0688 13.0843 8.89703 13.0843C7.76303 13.0843 6.81803 12.5173 6.76763 11.0809Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSidebarIcon3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sidebar-icon-3.0b22bf25.svg";
export { ForwardRef as ReactComponent };